export const EXIT_INTENT_SETTINGS_CONFIG = {
  exit_intent_title: {
    key: "exit_intent_title",
    label: "Form Title",
    tooltipText: "This text will appear at the top of the form.",
    placeholder: "Enter Form Title",
  },
  exit_intent_cta: {
    key: "exit_intent_cta",
    label: "Submit Form Button text",
    tooltipText:
      "This text will appear on the button through which the users will submit the form. Make it actionable and drive submissions!",
    placeholder: "Enter Button text",
  },
};

export const EXIT_INTENT_SETTINGS_KEY = "exit_intent_attributes";
export const EXIT_INTENT_INITIAL_VALUES = {
  exit_intent_title: "Hold on! Here’s an offer for you...",
  exit_intent_cta: "Book a free demo!",
};
